module.exports = "/images/no-photo.jpg?7c54e60faeecf9de893ee56fef62313d";